// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  coventryApiUrl: 'https://visa-monk-api.bookinterview.co.uk',
  production: true,
  pathapi: 'https://dev-backend.visamonk.ai/api',
  path: 'https://dev-backend.visamonk.ai/',
  visainterviewkey: "90ef82e1-7cac-4fad-aa04-fa2068564c8b",
  avansePuid: "M28N51FE",
  razorpayKeyId: "rzp_test_SYwlu2tJcRGJHm",
  razorpayKeySecret: "PP0zp9eQUEXl1ijfvyhA5Waf",
  googleCaptcha: "6Lcu0GoqAAAAAHHFIdM1jyOwFL9XitOsIc6zegCq",
  ramestoStartTestUrl: "https://staging.practiceforall.com/api/widget_authentication"
};
// Sub-domain
// - dev.Loan.foreignadmits.app

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.